// extracted by mini-css-extract-plugin
module.exports = {"tradingTimesContainer":"tradingTimes_tradingTimesContainer__3SoP6","worksDays":"tradingTimes_worksDays__1W-ex","active":"tradingTimes_active__3mEzg"};